var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-col',{staticClass:"dashboard-views__analytic-area",attrs:{"cols":"9"}},_vm._l((_vm.state.areas),function(zones){return _c('dashboard-module-base-area',{key:zones.id,attrs:{"area":zones.area,"options":zones.options}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }